<div>
    <p class="header">{{header}}</p>
    <p class="value">{{cleanedValue}}</p>
</div>